module.exports = __webpack_public_path__ + "static/media/escalade.585ae987.webp";